module.exports = __webpack_public_path__ + "static/Lilium superbum (Turk's cap Lily)-af40a0149a0c8c1e10c289e28c9d0153.jpg";